@if (userAccountInfoService.isLoggedIn() && ((this.isMobile1 && isuserHascard()) || !njoySpecificBuild)) {
  <div class="support" id="helpSupportContainer">
    <button class="help-button"
      (click)="openHelpPopup()"
      onclick="openModal();"
      [disabled]="isModalOpen"
      aria-label="Help"
      [class.isnjoySpecificBuild]="njoySpecificBuild"
      [class.session-pulse]="hasActiveSession">
      <div class="help-icon-container">
        <span class="help-icon-text">?</span>
      </div>
    </button>
    @if (hasActiveSession) {
      <div class="help-timer-badge">{{ sessionTimer }}</div>
    }
    <div id="helpPoupupWrapper" style="display:none">
      <div class="modal-backdrop-blur"></div>
      <ngx-smart-modal (onOpen)="handleModalEvents('onOpen', 'helpModal')" [hideDelay]="0"
        (onClose)="handleModalEvents('onClose', 'helpModal')"
        (onDismiss)="handleModalEvents('onDismiss', 'helpModal')" [closable]="false" #helpModal
        identifier="helpModal">
        <div class="modal-container flight-modal-container filter-modal1 modalAirportFilterInfo"
          (click)="$event.stopPropagation();" [ngStyle]="changeStyle()">
          <div class="modal-header">
            <span class="nameHeading">{{ 'help.Support' | translate }}</span>
            <button type="button" class="close" data-dismiss="modal" (click)="onSmartModelCancel('helpModal')">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M17.7333 6.29492L6.30469 17.7235" stroke="white" stroke-width="2.74286" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6.30469 6.29492L17.7333 17.7235" stroke="white" stroke-width="2.74286" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
            </button>
          </div>
          <div class="modal-body">
            <app-support [searchPopClicked]="searchPopClicked" (closeHelpComponent)="onSmartModelCancel('helpModal')">
              @if (hasActiveSession) {
                <div class="live-session-card">
                  <div class="lsc-header-row">
                    <span class="lsc-summary">Support Agent <strong>{{ sessionAgentName }}</strong> is assisting you</span>
                    <div class="lsc-right-controls">
                      <span class="lsc-info-icon" tabindex="0">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="12" cy="12" r="10"/>
                          <line x1="12" y1="16" x2="12" y2="12"/>
                          <line x1="12" y1="8" x2="12.01" y2="8"/>
                        </svg>
                        <div class="lsc-tooltip">
                          <strong>During this session, the agent will be able to:</strong>
                          <ul>
                            <li>Modify your travel bookings and reservations</li>
                            <li>Update your account preferences and settings</li>
                            <li>Make changes to your profile information</li>
                          </ul>
                        </div>
                      </span>
                      <span class="lsc-badge">
                        <span class="lsc-dot"></span>In Progress
                      </span>
                    </div>
                  </div>
                  <p class="lsc-time-row">
                    <span class="lsc-time-label">Time remaining:</span>
                    <span class="lsc-timer">{{ sessionTimer }}</span>
                  </p>
                  <button class="lsc-end-btn" (click)="endAgentSession(); $event.stopPropagation()">End Agent Session</button>
                </div>
              }
            </app-support>
          </div>
        </div>
      </ngx-smart-modal>
    </div>
  </div>
}
